var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _rect, _rect2, _path15, _path16, _path17;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBasement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 154,
    viewBox: "0 0 154 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M152.146 0H0V154H152.146V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M115.869 145.895H8V78.0469C8 74.1598 10.8387 70.9794 14.3081 70.9794H109.876C113.346 70.9794 116.185 74.1598 116.185 78.0469V145.895H115.869Z",
    fill: "#F78670"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0172 139.041C46.3469 138.707 46.3469 138.04 46.3469 137.706C46.3469 128.027 46.3469 118.682 46.3469 109.004C46.3469 100.66 40.0821 93.9855 31.839 92.9843C23.9256 92.3168 16.342 97.9904 15.0231 106C14.6934 107.001 14.6934 108.336 14.6934 109.338C14.6934 118.682 14.6934 128.027 14.6934 137.038C14.6934 137.706 14.6934 138.04 15.0231 138.707C25.5743 139.041 35.7957 139.041 46.0172 139.041Z",
    fill: "#02475E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0271 118.015C45.0271 122.354 45.0271 126.025 45.0271 129.696C45.0271 130.364 44.6974 130.697 44.0379 130.697C43.0487 130.697 42.0596 130.697 41.0704 130.697C40.0812 130.697 40.0812 130.364 40.0812 129.696C40.0812 128.361 40.0812 126.692 40.0812 125.357C40.0812 123.689 40.0812 123.689 38.4326 123.689C37.1137 123.689 35.7948 123.689 34.8056 123.689C34.1462 123.689 33.8165 123.355 33.8165 122.688C33.8165 121.019 33.8165 119.684 33.8165 118.015C33.8165 117.014 33.4867 116.68 32.4976 116.68C31.1787 116.68 29.8598 116.68 28.5409 116.68C27.8814 116.68 27.8814 116.346 27.8814 116.013C27.8814 114.344 27.8814 113.009 27.8814 111.34C27.8814 110.005 27.8814 110.005 26.2328 110.005C23.595 110.005 20.6275 110.005 17.9897 110.005C16.0114 110.005 16.0114 110.339 16.3411 108.003C17.0005 100.327 23.2653 94.6532 30.5192 94.6532C38.1029 94.6532 44.3676 100.327 45.0271 108.003C45.3568 111.34 45.0271 115.011 45.0271 118.015Z",
    fill: "#02475E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5195 132.031C35.1356 132.031 39.422 132.031 44.0382 132.031C45.0273 132.031 45.0273 132.365 45.0273 133.033C45.0273 134.368 45.0273 135.369 45.0273 136.704C45.0273 137.371 45.0273 137.705 44.0382 137.705C34.8059 137.705 25.9033 137.705 16.6711 137.705C16.0116 137.705 15.6819 137.371 15.6819 136.704C15.6819 135.369 15.6819 134.368 15.6819 133.033C15.6819 132.031 16.0116 132.031 16.6711 132.031C21.6169 132.031 26.2331 132.031 30.5195 132.031Z",
    fill: "#F78670",
    stroke: "#F78670",
    strokeWidth: 0.0999383,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5505 125.023C31.1774 125.023 34.4747 125.023 38.1016 125.023C38.7611 125.023 39.0908 125.357 39.0908 126.024C39.0908 127.359 39.0908 128.694 39.0908 129.695C39.0908 130.363 38.7611 130.363 38.4314 130.363C31.5071 130.363 24.2532 130.363 17.329 130.363C16.3398 130.697 16.0101 130.363 16.3398 129.695C16.3398 128.36 16.3398 127.359 16.3398 126.024C16.3398 125.023 16.6696 125.023 17.329 125.023C20.6262 125.023 23.9235 125.023 27.5505 125.023Z",
    fill: "#F78670",
    stroke: "#F78670",
    strokeWidth: 0.0999383,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5833 123.689C22.2752 123.689 19.6375 123.689 17.3294 123.689C16.6699 123.689 16.3402 123.689 16.3402 122.687C16.3402 121.352 16.3402 120.017 16.3402 119.016C16.3402 118.349 16.6699 118.015 17.3294 118.015C22.2752 118.015 27.2211 118.015 32.167 118.015C32.8264 118.015 32.8264 118.349 32.8264 118.683C32.8264 120.017 32.8264 121.352 32.8264 122.354C32.8264 123.355 32.4967 123.355 31.8372 123.355C29.1995 123.689 26.8914 123.689 24.5833 123.689Z",
    fill: "#F78670",
    stroke: "#F78670",
    strokeWidth: 0.0999383,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2874 111.007C22.6063 111.007 24.2549 111.007 25.5738 111.007C26.2332 111.007 26.563 111.007 26.563 111.674C26.563 113.009 26.563 114.344 26.563 115.679C26.563 116.346 26.2332 116.346 25.9035 116.346C22.936 116.346 19.9685 116.346 17.001 116.346C16.3415 116.68 16.0118 116.346 16.3415 116.013C16.3415 114.678 16.3415 113.343 16.3415 112.008C16.3415 111.34 16.6712 111.007 17.3307 111.007C18.6496 111.007 19.9685 111.007 21.2874 111.007Z",
    fill: "#F78670",
    stroke: "#F78670",
    strokeWidth: 0.0999383,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M114.185 8.98285H10C8.89543 8.98285 8 9.87828 8 10.9829V78.7197H116.185V10.9828C116.185 9.87828 115.289 8.98285 114.185 8.98285Z",
    fill: "#02475E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1353 33.912H25.5733C24.2544 33.912 22.9355 32.9108 22.9355 31.2421V21.5636C22.9355 20.2286 23.9247 19.2274 25.2436 19.2274H34.8056C36.1245 19.2274 37.1137 20.2286 37.1137 21.5636V31.2421C37.4434 32.9108 36.4542 33.912 35.1353 33.912Z",
    fill: "#FCEBE3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5562 33.9119H47.9942C46.6753 33.9119 45.6862 32.9107 45.6862 31.5757V21.5634C45.6862 20.2285 46.6753 19.2272 47.9942 19.2272H57.5562C58.8751 19.2272 59.8643 20.2285 59.8643 21.5634V31.242C59.8643 32.9107 58.8751 33.9119 57.5562 33.9119Z",
    fill: "#FCEBE3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6471 33.9119H70.085C68.7661 33.9119 67.777 32.9107 67.777 31.5757V21.5634C67.777 20.2285 68.7661 19.2272 70.085 19.2272H79.6471C80.9659 19.2272 81.9551 20.2285 81.9551 21.5634V31.242C82.2848 32.9107 80.9659 33.9119 79.6471 33.9119Z",
    fill: "#FCEBE3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M102.069 33.9119H92.507C91.1881 33.9119 90.199 32.9107 90.199 31.5757V21.5634C90.199 20.2285 91.1881 19.2272 92.507 19.2272H102.069C103.388 19.2272 104.377 20.2285 104.377 21.5634V31.242C104.377 32.9107 103.388 33.9119 102.069 33.9119Z",
    fill: "#FCEBE3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6649 81.971H22.9355V45.5931C22.9355 44.2581 24.2544 42.9232 25.5733 42.9232H45.0271C46.346 42.9232 47.6649 44.2581 47.6649 45.5931V81.971V81.971Z",
    fill: "#FCEBE3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 122.5,
    y: 34,
    width: 26,
    height: 26,
    fill: "#02475E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 122.5,
    y: 95.5,
    width: 26,
    height: 26,
    fill: "#F78670"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M129.391 53.7648L142.387 40.2899",
    stroke: "#F78670",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M142.387 53.7648L129.391 40.2899",
    stroke: "#F78670",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M127.172 111.566L131.61 116.057L144.606 102.903",
    stroke: "#02475E",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasement);
export default __webpack_public_path__ + "static/media/basement.8ef1d1e404437e3edb8cea8db7effae0.svg";
export { ForwardRef as ReactComponent };